import { useTranslation } from 'react-i18next'
import { resultSelector } from 'models/battle/selectors'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { resultType } from '../constants/resultType'
import { formatNumbers } from 'core/helpers/format-numbers'

import c from './assets/sass/result.module.scss'

export const Result = ({ selectedBet = 1000 }) => {
    const { t } = useTranslation()
    const result = useSelector(resultSelector)
    const isWin = result === resultType.win

    const winnings = isWin ? selectedBet * 2 : 0

    return (
        <div
            className={cn(c.component, {
                [c.win]: isWin,
                [c.lose]: !isWin,
            })}
        >
            <div className={c.row}>
                <span className={c.title}>
                    {isWin ? t('battle.result.win') : t('battle.result.lose')}
                </span>
                {isWin && (
                    <div className={c.prize}>
                        {t('battle.result.winnings')}
                        <span>{formatNumbers(winnings)}</span>
                    </div>
                )}
            </div>
        </div>
    )
}
